import React from 'react';

const ApplyIcon = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="40" height="40" rx="20" fill="#01619B" />
    <g>
      <path
        d="M16.5 30.5C16.5 30.7652 16.3946 31.0196 16.2071 31.2071C16.0196 31.3946 15.7652 31.5 15.5 31.5H10C9.73478 31.5 9.48043 31.3946 9.29289 31.2071C9.10536 31.0196 9 30.7652 9 30.5V9.5C9 9.23478 9.10536 8.98043 9.29289 8.79289C9.48043 8.60536 9.73478 8.5 10 8.5H15.5C15.7652 8.5 16.0196 8.60536 16.2071 8.79289C16.3946 8.98043 16.5 9.23478 16.5 9.5V30.5Z"
        stroke="white"
      />
      <path
        d="M14 22C14 22.1326 13.9473 22.2598 13.8536 22.3536C13.7598 22.4473 13.6326 22.5 13.5 22.5H11.5C11.3674 22.5 11.2402 22.4473 11.1464 22.3536C11.0527 22.2598 11 22.1326 11 22V11C11 10.8674 11.0527 10.7402 11.1464 10.6464C11.2402 10.5527 11.3674 10.5 11.5 10.5H13.5C13.6326 10.5 13.7598 10.5527 13.8536 10.6464C13.9473 10.7402 14 10.8674 14 11V22Z"
        stroke="white"
      />
      <path d="M11 13.5H14" stroke="white" />
      <path
        d="M24.5 30.5C24.5 30.7652 24.3946 31.0196 24.2071 31.2071C24.0196 31.3946 23.7652 31.5 23.5 31.5H17.5C17.2348 31.5 16.9804 31.3946 16.7929 31.2071C16.6054 31.0196 16.5 30.7652 16.5 30.5V9.5C16.5 9.23478 16.6054 8.98043 16.7929 8.79289C16.9804 8.60536 17.2348 8.5 17.5 8.5H23.5C23.7652 8.5 24.0196 8.60536 24.2071 8.79289C24.3946 8.98043 24.5 9.23478 24.5 9.5V30.5Z"
        stroke="white"
      />
      <path
        d="M22 22C22 22.1326 21.9473 22.2598 21.8536 22.3536C21.7598 22.4473 21.6326 22.5 21.5 22.5H19.5C19.3674 22.5 19.2402 22.4473 19.1464 22.3536C19.0527 22.2598 19 22.1326 19 22V11C19 10.8674 19.0527 10.7402 19.1464 10.6464C19.2402 10.5527 19.3674 10.5 19.5 10.5H21.5C21.6326 10.5 21.7598 10.5527 21.8536 10.6464C21.9473 10.7402 22 10.8674 22 11V22Z"
        stroke="white"
      />
      <path d="M19 13.5H22" stroke="white" />
      <path
        d="M32 30.5C32 30.7652 31.8946 31.0196 31.7071 31.2071C31.5196 31.3946 31.2652 31.5 31 31.5H25.5C25.2348 31.5 24.9804 31.3946 24.7929 31.2071C24.6054 31.0196 24.5 30.7652 24.5 30.5V9.5C24.5 9.23478 24.6054 8.98043 24.7929 8.79289C24.9804 8.60536 25.2348 8.5 25.5 8.5H31C31.2652 8.5 31.5196 8.60536 31.7071 8.79289C31.8946 8.98043 32 9.23478 32 9.5V30.5Z"
        stroke="white"
      />
      <path
        d="M30 22C30 22.1326 29.9473 22.2598 29.8536 22.3536C29.7598 22.4473 29.6326 22.5 29.5 22.5H27.5C27.3674 22.5 27.2402 22.4473 27.1464 22.3536C27.0527 22.2598 27 22.1326 27 22V11C27 10.8674 27.0527 10.7402 27.1464 10.6464C27.2402 10.5527 27.3674 10.5 27.5 10.5H29.5C29.6326 10.5 29.7598 10.5527 29.8536 10.6464C29.9473 10.7402 30 10.8674 30 11V22Z"
        stroke="white"
      />
      <path d="M27 13.5H30" stroke="white" />
      <path
        d="M11 27C11 27.3978 11.158 27.7794 11.4393 28.0607C11.7206 28.342 12.1022 28.5 12.5 28.5C12.8978 28.5 13.2794 28.342 13.5607 28.0607C13.842 27.7794 14 27.3978 14 27C14 26.6022 13.842 26.2206 13.5607 25.9393C13.2794 25.658 12.8978 25.5 12.5 25.5C12.1022 25.5 11.7206 25.658 11.4393 25.9393C11.158 26.2206 11 26.6022 11 27Z"
        stroke="white"
      />
      <path
        d="M19 27C19 27.3978 19.158 27.7794 19.4393 28.0607C19.7206 28.342 20.1022 28.5 20.5 28.5C20.8978 28.5 21.2794 28.342 21.5607 28.0607C21.842 27.7794 22 27.3978 22 27C22 26.6022 21.842 26.2206 21.5607 25.9393C21.2794 25.658 20.8978 25.5 20.5 25.5C20.1022 25.5 19.7206 25.658 19.4393 25.9393C19.158 26.2206 19 26.6022 19 27Z"
        stroke="white"
      />
      <path
        d="M27 27C27 27.3978 27.158 27.7794 27.4393 28.0607C27.7206 28.342 28.1022 28.5 28.5 28.5C28.8978 28.5 29.2794 28.342 29.5607 28.0607C29.842 27.7794 30 27.3978 30 27C30 26.6022 29.842 26.2206 29.5607 25.9393C29.2794 25.658 28.8978 25.5 28.5 25.5C28.1022 25.5 27.7206 25.658 27.4393 25.9393C27.158 26.2206 27 26.6022 27 27Z"
        stroke="white"
      />
    </g>
  </svg>
);

export default ApplyIcon;
